import { FilterType } from '~/client/src/shared/enums/FilterType'
import { TagIconType } from '~/client/src/shared/enums/TagIcon'
import { TagType } from '~/client/src/shared/enums/TagType'

export const FILE_TYPE_CATEGORY = 'FileType' as const
export const PROJECT_CATEGORY = 'Project' as const

type FilterCategoryKey =
  | TagType
  | typeof FILE_TYPE_CATEGORY
  | typeof PROJECT_CATEGORY
  | FilterType

/**
 * Extended tag interface for filter items that may have synthetic types.
 * Used in WorkflowFilters where we need to support categories like
 * 'FileType' and 'Project' that aren't part of the TagType enum.
 */
export interface IFilterTag {
  id: string
  name: string
  color: string
  iconName: TagIconType | string | null
  type: FilterCategoryKey
}
